import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function requestLastXQsIngestion(locationId, positions) {
	const query = gql`
		mutation requestLastXQsIngestion($locationId: String!, $positions: [String]) {
			requestLastXQsIngestion(locationId: $locationId, positions: $positions);
		}
	`;

	const variables = {
		locationId,
		positions,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.requestLastXQsIngestion;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function createPtoTypeHandler(locationId, position, input) {
	const query = gql`
		mutation CreatePtoType($locationId: String!, $position: String!, $input: InputPtoType) {
			createPtoType(locationId: $locationId, position: $position, input: $input) {
				_id
			}
		}
	`;

	const variables = {
		locationId,
		position,
		input,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.createPtoType;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}

export async function deletePtoTypeHandler(locationId, position, ptoTypeId) {
	const query = gql`
		mutation DeletePtoType($locationId: String!, $position: String!, $ptoTypeId: String!) {
			deletePtoType(locationId: $locationId, position: $position, ptoTypeId: $ptoTypeId) {
				_id
			}
		}
	`;

	const variables = {
		locationId,
		position,
		ptoTypeId,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.deletePtoType;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
